/*
 * NAJCIOR – WOW effects
 * Lekka, samodzielna animacja (bez zewnętrznych bibliotek):
 * konfetti + toast "Dodano do koszyka" w momencie otwarcia szuflady koszyka.
 * Nie ingeruje w logikę koszyka – działa niezależnie, wyłącznie wizualnie.
 */
(function () {
  if (window.__najciorWowInit) return;
  window.__najciorWowInit = true;

  var COLORS = ['#ff7e8d', '#0d0d0d', '#ffffff', '#ffb3bd', '#d1121f'];

  function injectStyles() {
    var css =
      '.najcior-confetti{position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:99999;overflow:hidden;}' +
      '.najcior-confetti span{position:absolute;top:-12px;border-radius:2px;opacity:0.95;animation:najciorFall linear forwards;}' +
      '@keyframes najciorFall{to{transform:translateY(110vh) rotate(540deg);opacity:0;}}' +
      '.najcior-toast{position:fixed;left:50%;bottom:24px;transform:translate(-50%,20px);background:#0d0d0d;color:#fff;' +
      'padding:12px 20px;border-radius:999px;font-size:14px;font-weight:600;letter-spacing:.2px;box-shadow:0 8px 24px rgba(0,0,0,.25);' +
      'z-index:100000;opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;}' +
      '.najcior-toast.show{opacity:1;transform:translate(-50%,0);}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  function fireConfetti() {
    var container = document.createElement('div');
    container.className = 'najcior-confetti';
    document.body.appendChild(container);

    var count = window.matchMedia('(max-width: 749px)').matches ? 26 : 46;
    for (var i = 0; i < count; i++) {
      var piece = document.createElement('span');
      var size = 6 + Math.random() * 6;
      piece.style.left = Math.random() * 100 + 'vw';
      piece.style.width = size + 'px';
      piece.style.height = size * 0.4 + 'px';
      piece.style.background = COLORS[Math.floor(Math.random() * COLORS.length)];
      piece.style.animationDuration = 1.4 + Math.random() * 1.2 + 's';
      piece.style.animationDelay = Math.random() * 0.15 + 's';
      container.appendChild(piece);
    }
    setTimeout(function () {
      container.remove();
    }, 2800);
  }

  function showToast(text) {
    var toast = document.createElement('div');
    toast.className = 'najcior-toast';
    toast.textContent = text;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('show');
    });
    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () {
        toast.remove();
      }, 300);
    }, 2200);
  }

  var lastCelebration = 0;
  function celebrate() {
    var now = Date.now();
    if (now - lastCelebration < 900) return; // guard against double-trigger
    lastCelebration = now;
    fireConfetti();
    showToast('Dodano do koszyka! 🎉');
  }

  function watchCartDrawer() {
    var drawer = document.getElementById('drawerMode');
    if (!drawer) return;

    var wasActive = drawer.classList.contains('active') || drawer.classList.contains('animate');

    var observer = new MutationObserver(function () {
      var isActive = drawer.classList.contains('active') || drawer.classList.contains('animate');
      if (isActive && !wasActive) {
        celebrate();
      }
      wasActive = isActive;
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Fallback: also celebrate right on a successful add-to-cart form submit
  // (covers themes/cart types where the drawer class toggle differs).
  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var button = form.querySelector('button[name="add"]');
    if (!button) return;
    var attempts = 0;
    var check = setInterval(function () {
      attempts++;
      var loading = button.classList.contains('loading');
      if (!loading || attempts > 40) {
        clearInterval(check);
        if (attempts > 1 && !button.disabled) {
          celebrate();
        }
      }
    }, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectStyles();
      watchCartDrawer();
    });
  } else {
    injectStyles();
    watchCartDrawer();
  }
})();
